<template>
  <div class="listing-form about-information margin-auto">
    <Card class="about-information-wrapper">
      <div slot="title" class="d-flex-center">
        <Avatar icon="md-person"/>
        <div><p style="color:#000;font-weight:bold">About *</p></div>
      </div>
      <div>
        <Form ref="AboutInformationForm" :model="value" :rules="formRules" label-position="top">
          <FormItem label="Company size" prop="size">
            <KSelect v-model="value.size" :optionList="company_sizes" class="k-select"/>
          </FormItem>
          <FormItem prop="founded">
            <span slot="label">
              Founded in
              <Tooltip max-width="300" placement="top" content="Year">[?]</Tooltip>
            </span>
            <DatePicker v-model="value.founded" format="yyyy" type="year" placeholder="Select year" class="fullwidth k-input"></DatePicker>
          </FormItem>
          <FormItem label="Founder(s)" prop="founder">
            <Input v-model="value.founder" class="k-input"/>
          </FormItem>
          <FormItem label="Website" prop="website">
            <Input v-model="value.website" class="k-input"/>
          </FormItem>
          <FormItem prop="customer_email">
            <span slot="label">
              Email address
              <Tooltip max-width="300" placement="top" content="Important: Email to receive customer inquiries">[?]</Tooltip>
            </span>
            <Input v-model="value.customer_email" class="k-input"/>
          </FormItem>
          <FormItem prop="telephone">
            <span slot="label">
              Phone number
              <Tooltip max-width="300" placement="top">[?]
                <div slot="content">
                  <p>+country code, area code, number</p>
                  <p>(visible only to the Kromnix team)</p>
                </div>
              </Tooltip>
            </span>
            <Input v-model="value.telephone" class="k-input"/>
          </FormItem>
          <FormItem prop="register_link">
            <span slot="label">
              Company Registration Number
              <Tooltip max-width="300" placement="top" content="VAT Number, Companies House, ...">[?]</Tooltip>
            </span>
            <Input v-model="value.register_link" class="k-input"/>
          </FormItem>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import KSelect from '@/components/ui/Select'
import moment from 'moment'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  components: {
    KSelect
  },

  watch: {
    'value.founded' (val) {
      this.value.founded = moment(val).format('YYYY')
    }
  },

  data () {
    return {
      formRules: {
        size: [
          { required: true, message: 'Please select company size', trigger: 'change' }
        ],
        founded: [
          { required: true, type: 'date', message: 'Please select founded year', trigger: 'change' }
        ],
        website: [
          { required: true, message: 'The website cannot be empty', trigger: 'blur' }
        ],
        customer_email: [
          { required: true, message: 'Email address cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
        register_link: [
          { required: true, message: 'The registration number cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$refs.AboutInformationForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.about-information {
  max-width:700px;
  .about-information-wrapper {
    .ivu-card-head {
      .ivu-avatar {
        background-color:#b00101;
        margin-right:10px
      }
    }
  }
}
</style>
<style lang="scss">
.about-information {
  form {
    label.ivu-form-item-label {
      font-weight: bold;
      color: #000;
    }
  }
}
</style>
